import CloseIcon from '@mui/icons-material/Close';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	useTheme,
} from '@mui/material';
import { ReactNode } from 'react';

interface DeleteModalProps {
	open: boolean;
	onClose: () => void;
	title?: string;
	children: ReactNode;
	actions: ReactNode;
}

export const DeleteModal = ({ open, onClose, title, children, actions }: DeleteModalProps) => {
	const theme = useTheme();

	return (
		<Dialog
			BackdropProps={{
				style: {
					backgroundColor: '#343A40',
					opacity: 0.1,
				},
			}}
			open={open}
			onClose={onClose}
			maxWidth="sm"
			sx={{
				'& .MuiPaper-root': {
					borderRadius: '15px',
					boxShadow: 'none',
					width: '540px',
					[theme.breakpoints.down('sm')]: {
						width: '390px',
					},
				},
			}}
		>
			<DialogTitle
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					borderBottom: '1px solid #E0E0E0',
					padding: '20px 20px 12px 20px',
				}}
			>
				{title}
				<IconButton onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent
				sx={{
					padding: '20px',
				}}
			>
				{children}
			</DialogContent>
			<DialogActions sx={{ borderTop: '1px solid #E0E0E0', padding: '20px' }}>
				{actions}
			</DialogActions>
		</Dialog>
	);
};
